// Import icon for history
import { HistoryOutlined } from "@mui/icons-material";
// Import the table component for displaying approver history
import { ApproverHistoryTable } from "./ApproverHistoryTable.component";
// Import custom tooltip component
import { CustomMUITooltip } from "./customMUIComponents";

// component to display approver history based on the selected item
export function ApproverHistoryDisplay({ item, data, isLoading }) {
  // Function to select the appropriate history data based on the item type
  function dataSelect(item) {
    switch (item) {
      case "email":
        return data.chefHistory;
      case "executiveChefEmail":
        return data.executiveChefHistory;
      case "HODDepartment":
        return data.HODHistory;
      default:
        break;
    }
  }

  // Check if the item is one of the known types before rendering
  if (
    item === "email" ||
    item === "executiveChefEmail" ||
    item === "HODDepartment"
  ) {
    return (
      <CustomMUITooltip
        content={
          <ApproverHistoryTable data={dataSelect(item)} isLoading={isLoading} />
        }
        icon={
          <HistoryOutlined
            style={{
              cursor: "pointer",
              marginLeft: "5px",
            }}
          />
        }
      />
    );
  }
}
